import client from '../../../utils/http-client'
import {injectable} from "inversify";

export class FooterService {
    constructor() {
        this.client = client;
    }

    async getFooterData() {
        const footerResponse = await client.get(`pages/2039`);
        if(footerResponse.status !== 200) {
            return false;
        }
        return footerResponse.data;
    }
}
injectable()(FooterService);
